"use strict";

class OthersController {
    /*@ngInject*/
    constructor($state, $stateParams, inventory, iconCache, $mdDialog, orderStore, utils, $q, auth) {
        "ngInject";
        _.extend(this, {
            name: 'others',
            $state: $state,
            $stateParams: $stateParams,
            $mdDialog: $mdDialog,
            inventory: inventory,
            getIconFor: iconCache,
            orderStore: orderStore,
            utils: utils,
            $q: $q,
            auth: auth
        });

        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId, false)
            .then(
                (order) => this.initialize(order),
                (error) => this.$q.reject(error)
            );
    }

    initialize(order) {
        this.order = order;

        var local_house_types = {
            '1 BHK': {cartonCount: 15, displayName: '1 BHK'},
            '2 BHK': {cartonCount: 25, displayName: '2 BHK'},
            '3 BHK': {cartonCount: 35, displayName: '3 BHK'},
            '3+ BHK': {cartonCount: 50, displayName: '3+ BHK'},
            'VEHICLE': {cartonCount: 0, displayName: 'vehicle'},
            'FEW_ITEMS': {cartonCount: 0, displayName: 'few items'},
            'DUPLEX_VILLA': {cartonCount: 60, displayName: 'duplex villa'}
        };

        var intercity_house_types = {
            '1 BHK': {cartonCount: 20, displayName: '1 BHK'},
            '2 BHK': {cartonCount: 30, displayName: '2 BHK'},
            '3 BHK': {cartonCount: 50, displayName: '3 BHK'},
            '3+ BHK': {cartonCount: 70, displayName: '3+ BHK'},
            'VEHICLE': {cartonCount: 0, displayName: 'vehicle'},
            'FEW_ITEMS': {cartonCount: 0, displayName: 'few items'},
            'DUPLEX_VILLA': {cartonCount: 75, displayName: 'duplex villa'}

        };

        this.houseTypes = this.order.move_type == 'local' ? local_house_types : intercity_house_types;

        this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
        this.itemColumns = this.getItemColumnsFromInventory(this.flatOrderItems);
        this.setItemsVolume();
    }

    getItemColumnsFromInventory(inventory) {
        let miscellaneousItemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .filter(item => !this.utils.isInPrimaryCategory(item))
            .value();

        return _(this.inventory.getMiscellaneousRootItems())
            .map(rootCategory => this.utils.getItemColumn(rootCategory.qualifiedName, [], 2))
            .map(rootCategory => {
                let matchingExistingItemsInInventory = _.filter(miscellaneousItemsInInventory, (item) =>
                    this.utils.compareQualifiedNameOf(item, rootCategory.qualifiedName, 2));
                rootCategory.children = matchingExistingItemsInInventory;
                return rootCategory;
            })
            .map(rootCategory => this.utils.withCountsOf(rootCategory.children, rootCategory, 3))
            .map(rootCategory => this.utils.withAllUniqueItemsFromRootOf(rootCategory, 6))
            .value();
    }

    onItemClick(evt) {
        let action = evt.action,
            selectedItem = evt.item,
            selectedItemColumn = evt.column,
            quantity = evt.quantity ? evt.quantity : 1;

        let selectedItemQualifiedName = selectedItem.qualifiedName;
        switch (action) {
            case 'add':
                let newItem = this.inventory.getItemWithQualifiedName(selectedItemQualifiedName);
                let newItems = _.fill(new Array(quantity), newItem);
                selectedItemColumn.children.push.apply(selectedItemColumn.children, newItems);
                this.flatOrderItems.push.apply(this.flatOrderItems, newItems);
                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 3);
                break;
            case 'subtract':
                // Remove item from itemColumn
                let indexOfSimilarItemInColumn = _.findLastIndex(selectedItemColumn.children, (item) =>
                    _.isUndefined(item._destroy) && this.utils.compareQualifiedNameOf(item, selectedItemQualifiedName, 3)
                );
                if (indexOfSimilarItemInColumn !== -1) {
                    let itemFromColumn = selectedItemColumn.children[indexOfSimilarItemInColumn];
                    if (itemFromColumn.id) {
                        itemFromColumn._destroy = true;
                    } else {
                        selectedItemColumn.children.splice(indexOfSimilarItemInColumn, 1);
                    }
                }

                // Mark item in flat order items as destroyed
                let indexOfItemInFlatOrderItems = _.findLastIndex(this.flatOrderItems, (item) =>
                    this.utils.compareQualifiedNameOf(item, selectedItemQualifiedName, 3)
                );
                if (indexOfItemInFlatOrderItems !== -1) {
                    let itemFromFlatList = this.flatOrderItems[indexOfItemInFlatOrderItems];
                    if (itemFromFlatList.id) {
                        itemFromFlatList._destroy = true;
                    } else {
                        this.flatOrderItems.splice(indexOfItemInFlatOrderItems, 1);
                    }
                }

                this.utils.updateCountsOf(selectedItemColumn, this.itemColumns, 3);
                break;
        }

        this.setItemsVolume();
    }

    setItemsVolume() {
        this.itemsVolume = _(this.flatOrderItems)
            .filter((item) => _.isUndefined(item._destroy))
            .sum('cubic_feet');
    }

    getUpdatedOrder(status) {
        let primaryItemsInInventory = _(this.flatOrderItems)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .filter(item => this.utils.isInPrimaryCategory(item))
            .value();
        let updatedInventoryItems = _(this.itemColumns).pluck('children').flatten().value().concat(primaryItemsInInventory);
        let mergedInventoryItems = this.utils.mergeOrderItems(updatedInventoryItems);

        let order = _.cloneDeep(this.order);
        order.order_items = mergedInventoryItems;
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.status = status;

        return order;
    }

    saveAsDraft() {
        let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);

        /**
         * If we have the user's contact details,
         * save order and stay on page.
         *
         * Else, take the user to the contact details page.
         * Once the details have been confirmed,
         *  redirect the user to this page.
         */

        this.orderLoader = this.orderStore.saveOrder(updatedOrder)
            .then(
                (order) => {
                    if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && updatedOrder.user_id)) {
                        this.utils.showAlertPopup('Order Saved!', 'Order Saved', 'Your order has been saved')
                            .then(() => {
                                this.initialize(order);
                                let nextState = this.utils.getAdminStateIfApplicable('base.others');
                                this.$state.go(nextState, {orderId: order.id});
                            });
                    } else {
                        let nextState = this.utils.getAdminStateIfApplicable('base.login'),
                            redirectState = this.utils.getAdminStateIfApplicable('base.others');
                        this.$state.go(nextState, {orderId: this.order.id, redirect: redirectState, showSavePopup: true});
                    }
                },
                (error) => {
                    console.log(error);
                    return error;
                }
            );
    }

    cartonBoxPopup(cartonBoxCount, callback) {
        var popupController = ($scope, $mdDialog) => {
            $scope.propertyType = this.houseTypes[this.order.property_type].displayName;
            $scope.cartonCount = this.houseTypes[this.order.property_type].cartonCount;
            $scope.yes = () => {
                $mdDialog.hide();
                let utilityColumn = _(this.itemColumns).find({item_id: 27});
                let cartonItem = _(utilityColumn.uniqueChildren).find({identifier: 382});
                this.onItemClick({action: 'add', item: cartonItem, column: utilityColumn, quantity: this.houseTypes[this.order.property_type].cartonCount - cartonBoxCount });
                callback();
            }
            $scope.no = () => {
                $mdDialog.hide();
                callback();
            }
        }

        this.$mdDialog.show({
            controller: popupController,
            template: require('common/popup.component/cartonbox.popup.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });

        popupController.$inject = ['$scope', '$mdDialog']; //to enable proper dependency injection during js minification

    }

    conditionsCheck(callback) {
        //check if enough carton boxes are used
        let utilityColumn = _(this.itemColumns).find({ item_id: 27}),
            cartonBoxInvItem = _(utilityColumn.uniqueChildren).find({identifier: 382}),
            cartonBoxCountObject = utilityColumn.counts[cartonBoxInvItem.qualifiedName],
            cartonBoxCount = cartonBoxCountObject ? cartonBoxCountObject.size : 0;

        if(cartonBoxCount < this.houseTypes[this.order.property_type].cartonCount) {
            this.cartonBoxPopup(cartonBoxCount, callback);
        } else {
            callback();
        }
    }

    next() {
        this.conditionsCheck(() => {
            this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.CREATED), true)
                .then(
                    (order) => {
                        let nextState;
                        /**
                         * If we have the user's contact details,
                         *  save order and continue to quotes page.
                         *
                         * Else, take the user to the contact details page.
                         * Once the details have been confirmed,
                         *  go to quotes page.
                         */
                        if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && order.user_id)) {
                            if(_.isEmpty(order.order_items)) {
                                nextState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                                return this.$state.go(nextState, {orderId: order.id});
                            }
                            let [moveType, propertyType] = [order.move_type, order.property_type],
                                quotePage = this.utils.getQuotePageForOrderWith(moveType, propertyType);

                            nextState = this.utils.getAdminStateIfApplicable(quotePage);
                            return this.$state.go(nextState, {orderId: order.id});
                        }

                        nextState = this.utils.getAdminStateIfApplicable('base.login');
                        this.$state.go(nextState, {orderId: order.id});
                    },
                    (error) => console.log(error)
                );
        });

    }
}

export default OthersController;



// WEBPACK FOOTER //
// ./client/app/components/others/others.controller.js